export const GET_SURVEY_LICENSES = "GET_SURVEY_LICENSES";
export const GET_SURVEY_LICENSES_SUCCESS = "GET_SURVEY_LICENSES_SUCCESS";
export const GET_SURVEY_LICENSES_FAIL = "GET_SURVEY_LICENSES_FAIL";

export const ADD_SURVEY_LICENSE = "ADD_SURVEY_LICENSE";
export const ADD_SURVEY_LICENSE_SUCCESS = "ADD_SURVEY_LICENSE_SUCCESS";
export const ADD_SURVEY_LICENSE_FAIL = "ADD_SURVEY_LICENSE_FAIL";

export const UPDATE_SURVEY_LICENSE = "UPDATE_SURVEY_LICENSE";
export const UPDATE_SURVEY_LICENSE_SUCCESS = "UPDATE_SURVEY_LICENSE_SUCCESS";
export const UPDATE_SURVEY_LICENSE_FAIL = "UPDATE_SURVEY_LICENSE_FAIL";

export const DELETE_SURVEY_LICENSE = "DELETE_SURVEY_LICENSE";
export const DELETE_SURVEY_LICENSE_SUCCESS = "DELETE_SURVEY_LICENSE_SUCCESS";
export const DELETE_SURVEY_LICENSE_FAIL = "DELETE_SURVEY_LICENSE_FAIL";

export const SET_SURVEY_LICENSE_FIELD_ERRORS = "SET_SURVEY_LICENSE_FIELD_ERRORS";
